<div class="layout-wrapper" [ngClass]="{'layout-sidebar-collapsed': isCollapsed}">
    <!-- Sidebar -->
    <aside class="layout-sidebar shadow-4">
        <div class="sidebar-header px-4 pt-4 pb-2 text-center">
            <div class="sidebar-logo-container flex align-items-center justify-content-center p-2 mb-4" 
                 [pTooltip]="isCollapsed ? 'AFactura' : ''" tooltipPosition="right">
                <i class="pi pi-file-import text-primary text-2xl"></i>
                <span class="logo-text ml-3 font-bold text-white-alpha-90" *ngIf="!isCollapsed">AFactura</span>
            </div>
            
            <button pButton icon="pi pi-bars" (click)="toggleSidebar()" 
                    class="p-button-text p-button-rounded text-white toggle-btn mb-4"></button>
        </div>

        <nav class="sidebar-nav px-3 flex-1">
            <ul class="list-none p-0 m-0">
                <li *ngFor="let item of menuItems" class="mb-2">
                    <a [routerLink]="item.route" routerLinkActive="active-link"
                       class="flex align-items-center p-3 border-round-xl text-white-alpha-70 transition-all transition-duration-300 hover:bg-white-alpha-10 no-underline"
                       [pTooltip]="isCollapsed ? item.label : ''" tooltipPosition="right">
                        <i [class]="item.icon + ' text-xl'"></i>
                        <span class="ml-3 font-medium nav-label" *ngIf="!isCollapsed">{{item.label}}</span>
                    </a>
                </li>
            </ul>
        </nav>

        <div class="sidebar-footer p-4 border-top-1 border-white-alpha-10">
            <div class="flex align-items-center p-2 border-round-xl hover:bg-white-alpha-10 cursor-pointer transition-all transition-duration-300"
                 (click)="logout()">
                <i class="pi pi-sign-out text-white-alpha-70 text-xl"></i>
                <span class="ml-3 font-medium text-white-alpha-70 nav-label" *ngIf="!isCollapsed">Cerrar Sesión</span>
            </div>
        </div>
    </aside>

    <!-- Main Content -->
    <main class="layout-main p-0 md:p-2">
        <!-- Header -->
        <header class="layout-header flex align-items-center justify-content-between px-4 py-3 bg-white shadow-1 mb-2 border-round-bottom-2xl mx-2">
            <div class="flex align-items-center">
                <button pButton icon="pi pi-bars" (click)="toggleSidebar()" 
                        class="p-button-text p-button-rounded text-900 mr-2 md:hidden"></button>
                <h2 class="text-xl font-bold m-0 text-900">AFactura <span class="text-400 font-normal">| Sistema de Gestión</span></h2>
            </div>
            
            <div class="flex align-items-center gap-3" *ngIf="currentUser$ | async as user">
                <div class="flex flex-column align-items-end mr-2 hidden sm:flex">
                    <span class="text-900 font-bold text-sm">{{user.nombreCompleto}}</span>
                    <span class="text-600 text-xs">{{user.nombreUsuario}}</span>
                </div>
                <div class="user-avatar bg-primary w-2.5rem h-2.5rem flex align-items-center justify-content-center border-round-circle shadow-1 cursor-pointer">
                    <i class="pi pi-user text-white"></i>
                </div>
                <button pButton icon="pi pi-sign-out" (click)="logout()" 
                        class="p-button-rounded p-button-text p-button-danger" pTooltip="Cerrar Sesión"></button>
            </div>
        </header>

        <div class="layout-content border-round-2xl bg-white shadow-1 p-3 md:p-4 min-h-screen overflow-hidden mx-2">
            <router-outlet></router-outlet>
        </div>
    </main>
</div>
